import React from 'react';
import {Stack, Typography} from '@mui/material';
import {MainHeader, PageWrapperLayout, Snackbar} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import {CustomBox} from './styles';
import {AddressForm} from 'presentation/components/ChangeData/Address/AddressForm';
import {useAddFavoritePlace} from './hooks/useAddFavoritePlace';

const {newAddress, saveAddress, addFavoritePlace} =
	translations['pt-br'].privateFlow.bookingFlow.location;
const {title} = translations['pt-br'].privateFlow.profile.changeData.address;

export function HealthGuideFavoritePlacesAdd() {
	const {
		isMobOrTab,
		handleBack,
		onSubmit,
		openAddFavoritePlaceSuccess,
		handleCloseFavoritePlaceSuccess,
		openAddFavoritePlaceError,
		handleCloseAddFavoritePlaceError,
		isPostingFavoritePlace,
	} = useAddFavoritePlace();

	return (
		<PageWrapperLayout title={newAddress}>
			<MainHeader title={newAddress} handleBack={handleBack} hideProfileMenu />
			<Stack
				paddingX={isMobOrTab ? undefined : 5}
				paddingY={isMobOrTab ? undefined : 3}
				gap={2}>
				<CustomBox $isMobOrTab={isMobOrTab}>
					<Typography variant="button" color="text.secondary">
						{title}
					</Typography>
					<AddressForm
						onCancel={handleBack}
						onSave={onSubmit}
						withoutAlertInfo
						withoutCancelButton
						responsiveButtons
						hasFavoriteAddressField
						saveLabel={saveAddress}
						loading={isPostingFavoritePlace}
					/>
				</CustomBox>
			</Stack>
			<Snackbar
				open={openAddFavoritePlaceError}
				message={addFavoritePlace.error}
				onClose={handleCloseAddFavoritePlaceError}
			/>
			<Snackbar
				open={openAddFavoritePlaceSuccess}
				message={addFavoritePlace.success}
				onClose={handleCloseFavoritePlaceSuccess}
				autoHideDuration={1500}
			/>
		</PageWrapperLayout>
	);
}
